import {DependencyInjectId} from "@@/package/const/DependencyInjectId";
import HttpClient from "@@/package/network/HttpClient";
import { type AxiosResponse } from "axios";
import { type ApplicationContextInterface } from "@@/package/application/applicationContext";
import type {PageModel} from "~~/package/mapper/common/model/PageModel";
import {HomeExploreCardModel} from "~~/package/mapper/home/model/HomeExploreCardModel";
import type CustomResponse from "~~/package/types/ResponseType";
import type {ArticleModel} from "~~/package/mapper/home/model/ArticleModel";

export default class HomeApi {

  protected http: HttpClient;

  constructor(context: ApplicationContextInterface) {
    this.http = context.getService<HttpClient>(DependencyInjectId.HttpClient);
  }

  public getArticleList(page: number, size: number, type: string, lang: string): Promise<AxiosResponse<CustomResponse<PageModel<ArticleModel>>>> {
    return this.http.get<AxiosResponse<CustomResponse<PageModel<ArticleModel>>>>("/articles", { page, size, type, lang}, true);
  }

  public getArticle(params: {id?: number, link?: string}): Promise<AxiosResponse<CustomResponse<ArticleModel>>> {
    return this.http.get<AxiosResponse<CustomResponse<ArticleModel>>>('/articles/detail', {id: params.id, link: params.link}, true);
  }
}
